var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67157 3.17157C3.5 4.34315 3.5 6.22876 3.5 10V14C3.5 17.7712 3.5 19.6569 4.67157 20.8284C5.84315 22 7.72876 22 11.5 22H13.5C17.2712 22 19.1569 22 20.3284 20.8284C21.5 19.6569 21.5 17.7712 21.5 14V10C21.5 6.22876 21.5 4.34315 20.3284 3.17157C19.1569 2 17.2712 2 13.5 2H11.5C7.72876 2 5.84315 2 4.67157 3.17157ZM7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H16.5C16.9142 7.25 17.25 7.58579 17.25 8C17.25 8.41421 16.9142 8.75 16.5 8.75H8.5C8.08579 8.75 7.75 8.41421 7.75 8ZM7.75 12C7.75 11.5858 8.08579 11.25 8.5 11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H8.5C8.08579 12.75 7.75 12.4142 7.75 12ZM8.5 15.25C8.08579 15.25 7.75 15.5858 7.75 16C7.75 16.4142 8.08579 16.75 8.5 16.75H13.5C13.9142 16.75 14.25 16.4142 14.25 16C14.25 15.5858 13.9142 15.25 13.5 15.25H8.5Z",
    fill: "#304FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDocument);
export default __webpack_public_path__ + "static/media/otherDocument.dcc82b1dcbf3fa710b309c746ca34d90.svg";
export { ForwardRef as ReactComponent };